export const SampleMessage = "SampleMessage"
export const LocationMessage = "LocationMessage"
export const GlobalMessage = "GlobalMessage"